import React, { useState } from 'react';
import { Section } from './ui/Section';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: '¿Cómo recibo el material después de comprar?',
  a: 'Inmediatamente después de confirmar el pago recibís un email con el acceso a todos los tomos y bonos en formato PDF digital. Acceso en menos de 5 minutos.'
}, {
  q: '¿Sirve para profesores con poca experiencia o solo para los avanzados?',
  a: 'Sirve para todos los niveles. Los tomos están estructurados con progresiones desde iniciación hasta competencia. Tanto el profesor principiante como el experimentado encuentran valor inmediato.'
}, {
  q: '¿Es editable? ¿Puedo modificarlo?',
  a: 'El material se entrega en PDF. Podés imprimirlo y usarlo libremente en tus clases. No está habilitada la edición para proteger los derechos de autor del contenido.'
}, {
  q: '¿Los 6 bonos están en las dos ofertas?',
  a: 'Sí. Los 6 bonos estratégicos están incluidos en ambas opciones sin costo adicional.'
}, {
  q: '¿Sirve si doy clases individuales o solo para grupos?',
  a: 'Sirve para ambas modalidades. Cada clase incluye adaptaciones para trabajo individual y grupal.'
}, {
  q: '¿Sirve si tengo alumnos de distintas edades al mismo tiempo?',
  a: 'Sí. Cada ejercicio incluye variaciones para Nivel 1, Nivel 2 y Nivel 3 dentro de la misma clase. Grupos heterogéneos completamente resueltos.'
}, {
  q: '¿Qué diferencia tiene con otros materiales de gimnasia artística?',
  a: 'Es el único sistema que incluye protocolos de spotting detallados, análisis por fases de cada elemento, progresiones por los 4 aparatos principales y gestión completa del negocio en un solo pack.'
}, {
  q: '¿Por qué elegir el Pack Élite y no el estándar?',
  a: 'Si además de enseñar querés hacer crecer tu academia, el Pack Élite te da las coreografías listas para exhibiciones y el sistema completo para gestionar y rentabilizar tu espacio.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días de garantía total. Si no es lo que esperabas te devolvemos el 100% del dinero sin ninguna condición.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="bg-navy-800/50 border-y border-navy-800" data-id="element-94">
      <div className="text-center mb-5 md:mb-12" data-id="element-95">
        <h2 className="text-xl md:text-4xl font-black text-white" data-id="element-96">
          PREGUNTAS FRECUENTES
        </h2>
      </div>

      <div className="max-w-3xl mx-auto space-y-2 md:space-y-4" data-id="element-97">
        {faqs.map((faq, i) => <div key={i} className="bg-navy-900 border border-navy-700 rounded-lg md:rounded-xl overflow-hidden" data-id="element-98">
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-3 py-3 md:px-6 md:py-5 text-left flex items-center justify-between focus:outline-none" data-id="element-99">
              <span className="font-bold text-white pr-3 text-sm md:text-base" data-id="element-100">
                {faq.q}
              </span>
              <ChevronDown className={`w-4 h-4 md:w-5 md:h-5 text-gold-400 transition-transform duration-300 flex-shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-101" />
            </button>
            <AnimatePresence data-id="element-102">
              {openIndex === i && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-103">
                  <div className="px-3 pb-3 md:px-6 md:pb-5 text-gray-400 leading-relaxed border-t border-navy-800 pt-3 md:pt-4 text-sm md:text-base" data-id="element-104">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
}